define('user',[],function() {
    'use strict';

    return function(viewModel, data) {
        var self            = this,
            userData        = data.user,
            userRoles		= [];

        if (!data || !data.current) {
            return;
        }

        if(userData.roles != null){
            userData.roles.forEach(function(userRole){
                userRoles.push(userRole.systemName.toLowerCase());
            });
        }

        /* Public functions */

        self.hasRoles = function(roles) {
            var has = false;
            roles.forEach(function(role){
                if(userRoles.indexOf(role) > -1) has = true;
            });
            return has;
        };

        self.id = function() {
            var id = userData.id;
            return id;
        };

        self.firstName = function() {
            return userData.firstName;
        };

        self.lastName = function() {
            return userData.lastName;
        };

        self.fullName = function() {
            var name = userData.firstName +" "+ userData.lastName;
            return name;
        };

        self.nickname = function() {
            return userData.nickname;
        };

        self.email = function() {
            return userData.email;
        };

        self.isPageVisitedById = function(contentEntityId) {
            var is = false;

            if (userData && userData.hasOwnProperty('answers') && Array.isArray(userData.answers)) {
                userData.answers.forEach(function(answer){
                    if(answer.contentEntityId === contentEntityId){
                        is = answer.visited;
                    }
                });
            }

            return is;
        };

        self.isPageVisitedByIndex = function(index) {
            var is = false;

            if (userData.answers && userData.answers[index]) {
                is = userData.answers[index].visited;
            }

            return is;
        };

        self.hasCommentingRoundAccess = function() {
            return userData.hasCommentingRoundAccess;
        }

    };
});

